<template>
  <a-modal
    :visible="modalVisible"
    class="modal-main"
    :footer="null"
    :closable="false"
    :forceRender="true"
    @cancel="handleCloseModal"
    width="350px"
  >
    <div :id="qrcodeId" ref="qrcode"></div>
  </a-modal>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
  name: 'QRCodeModal',
  data() {
    return {
      modalVisible: false,
      qrCodeUrl: undefined,
      qrcodeId: 'qrcode' + Math.random().toString(),
    }
  },
  methods: {
    showModal(text) {
      this.modalVisible = true
      this.qrCodeUrl = text
      document.getElementById(this.qrcodeId).innerHTML = ''
      this.qrCode()
    },
    qrCode() {
      new QRCode(this.qrcodeId, {
        width: 200,
        height: 200,
        text: this.qrCodeUrl,
      })
    },
    handleCloseModal() {
      this.modalVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-main {
  user-select: none;
  #qrcode {
    user-select: none;
  }
}
</style>
